import React, { useState, useEffect } from 'react';
import {NavLink} from 'react-router-dom';
import axios from 'axios';
import { useAuthContext } from '../hooks/useAuthContext';

const PurchaseOrdersOverview = () => {
    const [watches, setWatches] = useState(); //watches variable will hold all purchase orders returned from API call to DB
    const {user} = useAuthContext(); //grabbing the user object that is returned from the useAuthContext hook
    const purStatus = 'Paid';
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();

    //get screensize
    const getScreenSize = () => {
        const width = window.innerWidth;
        if (width < 650) return 'small';
        if (width >= 650 && width < 1050) return 'medium'
        return 'large';
    };
    const [screenSize, setScreenSize] = useState(getScreenSize());

    useEffect(() => {
        const getPurchases = async () => {
            try {
                // eslint-disable-next-line
                const response = await axios.get(process.env.REACT_APP_SERVER_URL + '/api/purchaseOrders' + `?purStatus=${purStatus}&month=${month}&year=${year}`, 
                    {headers: {'Authorization': `Bearer ${user.token}`}}
                ); //get all active purchase orders
                setWatches(response.data);
            } catch (error) {
                console.error('Failed to get all watch requests: ' + error.message);
            }
        }

        if (user) {
            getPurchases();
        }

        const handleResize = () => {
            setScreenSize(getScreenSize());
          };
      
        window.addEventListener('resize', handleResize);
      
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [user, month, year]);

    return(
        <NavLink className='nav-link' to='/main/purchase-orders'>
            <div className="overview">
                <h2>Monthly Purchases</h2>
                <table className="overviewTable table">
                    <thead>
                        <tr>
                            {screenSize !== 'small' && <th>Purchase Date</th>}
                            {screenSize === 'large' && <th>Brand</th>}
                            <th>Model</th>
                            {screenSize !== 'small' && <th>Year</th>}
                            {screenSize === 'large' && <th>Condition</th>}
                            {screenSize === 'large' && <th>Purchase Status</th>}
                            <th>Purchase Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {watches && watches.slice(0,5).map((watch) => (
                            <tr key={watch._id}>
                                {screenSize !== 'small' && <td>{watch.purOrder.purDate.slice(0,10)}</td>}
                                {screenSize === 'large' && <td>{watch.brand}</td>}
                                <td>{watch.model}</td>
                                {screenSize !== 'small' && <td>{watch.year}</td>}
                                {screenSize === 'large' && <td>{watch.condition}</td>}
                                {screenSize === 'large' && <td>{watch.purOrder.purStatus}</td>}
                                <td>${watch.purOrder.purPrice}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </NavLink>

    )
}

export default PurchaseOrdersOverview;